import React from 'react';
import { Instagram, Facebook, Youtube, Home, Phone, Mail, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className="font-sans">
      <footer className="bg-gray-900 text-white pt-12 pb-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-between">
            {/* Première colonne - Logo et description */}
            <div className="w-full md:w-1/4 p-4 mb-6 md:mb-0">
              <div className="flex items-center mb-4">
                <Heart className="text-yellow-500 mr-2" size={24} />
                <h5 className="text-xl font-bold text-yellow-500">PERSPECTIVE CONGO</h5>
              </div>
              <p className="text-gray-300 mb-4 leading-relaxed">
                Restons en contact, et pensons aussi au Congo. Ensemble pour un avenir meilleur.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-yellow-500 p-2 rounded-full transition-all duration-300">
                  <Instagram className="text-white" size={20} />
                </a>
                <a href="https://www.facebook.com/perspective.congo" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-yellow-500 p-2 rounded-full transition-all duration-300">
                  <Facebook className="text-white" size={20} />
                </a>
                <a href="https://www.youtube.com/channel/UChlYfxS0yWyWs0kaL_3ELRw" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-yellow-500 p-2 rounded-full transition-all duration-300">
                  <Youtube className="text-white" size={20} />
                </a>
              </div>
            </div>

            {/* Deuxième colonne - Navigation */}
            <div className="w-full md:w-1/5 p-4 mb-6 md:mb-0">
              <h5 className="text-lg font-bold mb-4 border-b border-yellow-500 pb-2 inline-block">Navigation</h5>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 flex items-center">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link to="/apropos" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 flex items-center">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                    À propos
                  </Link>
                </li>
                <li>
                  <Link to="/actualité" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 flex items-center">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                    Actualités
                  </Link>
                </li>
                <li>
                  <Link to="/evenement" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 flex items-center">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                    Événements
                  </Link>
                </li>
                <li>
                  <Link to="/galerie" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 flex items-center">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                    Galerie
                  </Link>
                </li>
              </ul>
            </div>

            {/* Troisième colonne - Partenaires */}
            <div className="w-full md:w-1/5 p-4 mb-6 md:mb-0">
              <h5 className="text-lg font-bold mb-4 border-b border-yellow-500 pb-2 inline-block">Partenaires</h5>
              <ul className="space-y-3">
                <li className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                  Association NSP
                </li>
                <li className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                  Maison de l'Afrique
                </li>
                <li className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                  AECF
                </li>
                <li className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                  Ambassade du Congo
                </li>
                <li className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                  Association le puzzle
                </li>
              </ul>
            </div>

            {/* Quatrième colonne - Contact */}
            <div className="w-full md:w-1/4 p-4">
              <h5 className="text-lg font-bold mb-4 border-b border-yellow-500 pb-2 inline-block">Contactez-nous</h5>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <Home className="text-yellow-500 mt-1 mr-3 flex-shrink-0" size={18} />
                  <span className="text-gray-300">
                    Maison de l'Afrique à Nantes<br />
                    1 rue Louis Preaubert<br />
                    44100 Nantes
                  </span>
                </li>
                <li className="flex items-center">
                  <Phone className="text-yellow-500 mr-3" size={18} />
                  <span className="text-gray-300">+33 6 65 32 87 71</span>
                </li>
                <li className="flex items-center">
                  <Mail className="text-yellow-500 mr-3" size={18} />
                  <a href="mailto:contact@perspectivecongo.com" className="text-gray-300 hover:text-yellow-500 transition-colors duration-300">
                    contact@perspectivecongo.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Perspective Congo. Tous droits réservés. | 
            <a href="#" className="hover:text-blue-400 ml-2">Design by consulting informatic's</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;